import React, { Component } from 'react';
import { Upload, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { LoadingModal } from '@HOC';
import { fileToMd5 } from '@util';

import Debounce from 'lodash-decorators/debounce';
const pdf_url = 'http://test-img.freshfood.cn/20201229163252_pdf.png';

class UploadImage extends Component {
  constructor(props) {
    super(props);
    this.uploadMaxInfo = this.uploadMaxInfo.bind(this);
  }

  @Debounce(600)
  uploadMaxInfo(data) {
    message.info(`最多上传${data}个文件`);
  }

  qualificationsBeforeUpload = async (file, fileList) => {
    const {
      maxCount = 10,
      maxSize = 1048576,
      fileList: currentFileList,
      accept = 'application/pdf,image/jpg,image/jpeg,image/png',
    } = this.props;
    if (!accept.includes(file.type)) {
      message.error(`${file.name}不符合文件上传类型`);
      return new Promise((resolve, reject) => reject());
    }

    if (file.size > maxSize) {
      message.error(`文件大小不能超过${maxSize / 1024 / 1024}M，请修改后重新导入`);
      return new Promise((resolve, reject) => reject());
    }

    const allNum = fileList.length + (currentFileList ? currentFileList.length : 0);
    if (allNum > maxCount) {
      this.uploadMaxInfo(maxCount);
      return new Promise((resolve, reject) => reject());
    }
    const md5 = await fileToMd5(file);
    // eslint-disable-next-line no-param-reassign
    file.md5 = md5;
    LoadingModal.showLoading('文件上传中, 请耐心等待.....');
    return true;
  };

  qualificationsChange = info => {
    const { onChange } = this.props;
    if (
      info?.file.response &&
      info?.file?.response.code &&
      info?.file?.response.code !== 200000 &&
      info?.file?.status !== 'removed'
    ) {
      message.error(info?.file?.response.message);
    }
    if (
      info?.file.response &&
      info?.file?.response.code &&
      info?.file?.response.code === 200000 &&
      info?.file?.status === 'done' &&
      info?.file?.response.data.errorOcrMsg
    ) {
      message.error(info?.file?.response.data.errorOcrMsg);
    }
    info.fileList.forEach(i => {
      if (i.type === 'application/pdf' && i.status === 'done') {
        i.thumbUrl = pdf_url;
      }
      if (i.response?.data) {
        i.imgUrl = i.response?.data;
      } else if (!i.imgUrl && i.status !== 'uploading') {
        i.status = 'error';
      }
    });
    if (onChange) {
      onChange(info);
    }
    if (info.file.status === 'done') {
      LoadingModal.hideLoading();
    }
  };

  // 预览
  previewImg = async file => {
    console.log('file--', file);
    if (file.response) {
      window.open(file.response?.data.url || file.response.data);
    } else {
      if (file.pdf_url) {
        window.open(file.pdf_url);
      } else {
        window.open(file.url);
      }
    }
  };
  render() {
    const {
      maxCount = 10,
      fileList,
      action,
      headers,
      multiple = true,
      accept = 'image/jpg,image/jpeg,image/png',
      disabled,
    } = this.props;

    const uploadButton = (
      <div>
        <PlusOutlined />
        <div style={{ marginTop: 8 }}>Upload</div>
      </div>
    );

    return (
      <Upload
        multiple={multiple}
        accept={accept}
        action={action}
        listType="picture-card"
        fileList={fileList}
        beforeUpload={this.qualificationsBeforeUpload}
        onChange={this.qualificationsChange}
        headers={headers}
        onPreview={this.previewImg}
        disabled={disabled}>
        {fileList?.length < maxCount && uploadButton}
      </Upload>
    );
  }
}

export default UploadImage;
